import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameVideoList = paths['/v4/game/{slug}/video/'];

const getGameVideoList = createRequest<GameVideoList>('/pc/v4/game/{slug}/video/');

export default getGameVideoList;
